import React from 'react';
import classNames from 'classnames';
import { formatShortDateFromNow } from '../../../../../utils/date-utils/dateUtils';
import { Hyperlink } from '../../../../../components/Hyperlink';
import { buildUrlWithParameters } from '../../../../../utils/url-utils/urlUtils';
import { NotificationReadStatus } from '../status/NotificationReadStatus';
import { NotificationFolderWatcherType } from '../../../notification.types';
import { sendNotificationClickedEvent } from '../../../notificationUtils';
import { Connect } from './NotificationFolderWatcherContainer';

type Props = {
  notification: NotificationFolderWatcherType;
  notificationClicked: Function;
  isAlreadyRead: boolean;
};

export class RawNotificationFolderWatcher extends React.Component<Props> {
  onNotificationClicked = (event: React.MouseEvent<HTMLAnchorElement>) => {
    const { notification, notificationClicked } = this.props;
    sendNotificationClickedEvent();
    notificationClicked(notification)(event);
  };

  render() {
    const { notification, isAlreadyRead } = this.props;
    const { folderWatcher } = this.props.notification.data;
    return (
      <Hyperlink
        className="notification-list__link"
        href={buildUrlWithParameters(notification.link, {
          source_notification_id: notification.id,
        })}
        onClick={this.onNotificationClicked}
      >
        <NotificationReadStatus notificationId={notification.id} />
        <span className="notification-list__link__content">
          <span
            className={classNames('notification-watcher__title', {
              'notification-watcher__title--new': !isAlreadyRead,
            })}
          >
            {folderWatcher.folderTitle}
          </span>
          <span className="notification-watcher__decision">
            {folderWatcher.title}
          </span>
          <span className="notification-list__link__date">
            {formatShortDateFromNow(notification.date)}
          </span>
        </span>
      </Hyperlink>
    );
  }
}

export const NotificationFolderWatcher = Connect(RawNotificationFolderWatcher);
